import * as React from "react"
import { CollectionSearch } from "./collection-search"
import type { CollectionSearchProps } from "./types"

export interface DivisionSearchProps
  extends Omit<CollectionSearchProps, "collection" | "displayMode"> {
  /** Additional filter beyond default division filtering */
  filter?: Record<string, any>
}

/**
 * DivisionSearch - Pre-configured CollectionSearch for divisions.
 *
 * @example
 * <DivisionSearch
 *   value={divisionId}
 *   onChange={(option) => setDivisionId(option?.value || null)}
 *   placeholder="Select a division..."
 * />
 */
export function DivisionSearch({
  placeholder = "Search divisions...",
  ...props
}: DivisionSearchProps) {
  return (
    <CollectionSearch
      {...props}
      collection="divisions"
      displayMode="default"
      placeholder={placeholder}
    />
  )
}
